import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { CoreCommonModule } from "@core/common.module";

import { LoginComponent } from "./login/login.component";
import { ErrorInterceptorProvider } from "app/main/helpers/error.interceptor";
import { AuthLoginV2Component } from "./auth-login-v2/auth-login-v2.component";

// routing
const routes: Routes = [
  {
    path: "login/:token",
    component: LoginComponent,
    data: { animation: "auth" },
  },
  {
    path: "sign-in",
    component: AuthLoginV2Component,
    data: { animation: "auth" },
  },
];

@NgModule({
  declarations: [LoginComponent, AuthLoginV2Component],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CoreCommonModule,
  ],
  providers: [
    // ErrorInterceptorProvider,
  ],
})
export class AuthenticationModule {}
